import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')``;
export const DateRangeWrapper = styled('div')`
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: 100%;

  .dateRangeWrapper {
    width: 100%;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;

    .selectWrapper {
      min-width: 200px;
      flex: 0;
    }

    .datesWrapper {
      width: 350px;
    }
  }
`;
